import React from "react";

const Icon = ({ icon, height, width, color }) => {
  const svg = {
    sync: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? "34.026"}
        height={height ?? "27.52"}
        viewBox="0 0 34.026 27.52"
      >
        <g transform="translate(57.383 -9.536) rotate(135)">
          <path
            fill={color || "#fff"}
            d="M35.946,12c0-4.448,3.749-8.129,7.995-8.85l-.495,2.764L47.86,2.25,43.446-1.414,43.83,1.6c-5.08.732-9.384,5.118-9.384,10.4A10.493,10.493,0,0,0,39.5,20.96l1.3-.978A9,9,0,0,1,35.946,12Z"
          />
          <path
            fill={color || "#fff"}
            d="M253.12,78.776a10.493,10.493,0,0,0-5.054-8.96l-1.3.978a8.976,8.976,0,0,1-2.642,16.829l.448-3.152-4.862,4.055,5.428,3.956-1.014-3.329A10.505,10.505,0,0,0,253.12,78.776Z"
            transform="translate(-197.674 -66.776)"
          />
        </g>
      </svg>
    ),
    bell: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18.99"
        height="24"
        viewBox="0 0 18.99 24"
      >
        <path
          fill={color || "#fff"}
          d="M72.033,19.1A3.729,3.729,0,0,1,70.9,17.556,17.854,17.854,0,0,1,69.718,10.5c0-.009,0-.018,0-.027A6.81,6.81,0,0,0,65.709,4.3V2.674A2.674,2.674,0,0,0,63.04,0h-.221A2.674,2.674,0,0,0,60.15,2.674V4.3a6.81,6.81,0,0,0-4.009,6.2,17.855,17.855,0,0,1-1.181,7.055A3.729,3.729,0,0,1,53.826,19.1a.684.684,0,0,0-.375.777.715.715,0,0,0,.705.55H59.31a3.62,3.62,0,0,0,7.24,0H71.7a.715.715,0,0,0,.705-.55A.684.684,0,0,0,72.033,19.1ZM61.556,2.674a1.265,1.265,0,0,1,1.263-1.265h.221A1.265,1.265,0,0,1,64.3,2.674V3.842a6.81,6.81,0,0,0-2.747,0V2.674Zm1.373,19.918a2.219,2.219,0,0,1-2.214-2.165h4.427A2.219,2.219,0,0,1,62.929,22.591Zm2.831-3.574h-10a7.371,7.371,0,0,0,.368-.647,17.8,17.8,0,0,0,1.42-7.87,5.382,5.382,0,1,1,10.764,0c0,.009,0,.017,0,.026a17.766,17.766,0,0,0,1.42,7.842,7.371,7.371,0,0,0,.368.647Z"
          transform="translate(-53.434 0)"
        />
      </svg>
    ),
    uploadImage: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20.322"
        height="18.03"
        viewBox="0 0 20.322 18.03"
      >
        <g transform="translate(0.15 -23.85)">
          <g transform="translate(0 24)">
            <g transform="translate(0 0)">
              <circle
                fill="#003E85"
                stroke="#003E85"
                strokeWidth="0.3px"
                cx="1.376"
                cy="1.376"
                r="1.376"
                transform="translate(6.171 4.375)"
              />
              <path
                fill="#003E85"
                stroke="#003E85"
                strokeWidth="0.3px"
                d="M18.838,34.814a4.236,4.236,0,0,0-2.369-1.127V26.694a2.751,2.751,0,0,0-.783-1.911A2.67,2.67,0,0,0,13.775,24H2.694a2.751,2.751,0,0,0-1.911.783A2.67,2.67,0,0,0,0,26.694V38.1A2.751,2.751,0,0,0,.783,40.01a2.669,2.669,0,0,0,1.911.783H13.412a4.042,4.042,0,0,0,5.426-5.98ZM1.013,26.694a1.6,1.6,0,0,1,.5-1.165,1.676,1.676,0,0,1,1.185-.5H13.775a1.7,1.7,0,0,1,1.681,1.681v5.961l-2.828-2.828a.513.513,0,0,0-.726,0l-4.26,4.28-2.885-2.9a.513.513,0,0,0-.726,0L1.013,34.279ZM2.675,39.819v-.038a1.676,1.676,0,0,1-1.185-.5A1.744,1.744,0,0,1,1.013,38.1V35.731l3.382-3.4,2.885,2.885a.531.531,0,0,0,.726,0l4.26-4.28,2.789,2.808-.172.057a1.774,1.774,0,0,0-.248.076c-.076.019-.153.057-.229.076a.572.572,0,0,0-.153.076,1.775,1.775,0,0,0-.191.1l-.287.172c-.057.038-.1.057-.153.1-.038.019-.057.038-.1.057a2.305,2.305,0,0,0-.459.4,4.042,4.042,0,0,0-1.185,2.866,4.2,4.2,0,0,0,.1.841c.019.076.038.134.057.21.057.191.115.382.191.573v.019a3.5,3.5,0,0,0,.248.459Zm15.418,0a3.022,3.022,0,0,1-4.222.038c-.076-.076-.153-.172-.229-.248-.057-.057-.115-.134-.172-.191a1.814,1.814,0,0,1-.191-.325c-.038-.076-.076-.134-.115-.21a1.614,1.614,0,0,1-.1-.325c-.019-.076-.057-.172-.076-.248a3.162,3.162,0,0,1-.057-.611,3.067,3.067,0,0,1,.879-2.14,2.954,2.954,0,0,1,2.14-.879,3.067,3.067,0,0,1,2.14.879,2.986,2.986,0,0,1,.879,2.14A3.056,3.056,0,0,1,18.093,39.819Z"
                transform="translate(0 -24)"
              />
              <path
                fill="#003E85"
                stroke="#003E85"
                strokeWidth="0.3px"
                d="M300.654,264.553a.668.668,0,0,0-.172-.115.558.558,0,0,0-.172-.038h-.038a.558.558,0,0,0-.172.038.451.451,0,0,0-.172.115l-1.185,1.185a.513.513,0,0,0,.726.726l.306-.306v2.1a.516.516,0,1,0,1.032,0v-2.1l.306.306a.513.513,0,1,0,.726-.726Z"
                transform="translate(-284.338 -252.918)"
              />
            </g>
          </g>
        </g>
      </svg>
    ),
    calendar: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17.336"
        height="17.729"
        viewBox="0 0 17.336 17.729"
      >
        <g transform="translate(-5.411)">
          <g transform="translate(5.411)">
            <path
              fill={"#003E85"}
              d="M119.244,258.644a.4.4,0,0,0-.4-.4h-1.4a.4.4,0,0,0-.4.4v1.4a.4.4,0,0,0,.4.4h1.4a.4.4,0,0,0,.4-.4v-1.4Z"
              transform="translate(-112.981 -248.863)"
            />
            <path
              fill={"#003E85"}
              d="M215.879,258.644a.4.4,0,0,0-.4-.4h-1.4a.4.4,0,0,0-.4.4v1.4a.4.4,0,0,0,.4.4h1.4a.4.4,0,0,0,.4-.4Z"
              transform="translate(-206.106 -248.863)"
            />
            <path
              fill={"#003E85"}
              d="M312.507,258.644a.4.4,0,0,0-.4-.4h-1.4a.4.4,0,0,0-.4.4v1.4a.4.4,0,0,0,.4.4h1.4a.4.4,0,0,0,.4-.4Z"
              transform="translate(-299.225 -248.863)"
            />
            <path
              fill={"#003E85"}
              d="M119.244,355.277a.4.4,0,0,0-.4-.4h-1.4a.4.4,0,0,0-.4.4v1.4a.4.4,0,0,0,.4.4h1.4a.4.4,0,0,0,.4-.4v-1.4Z"
              transform="translate(-112.981 -341.986)"
            />
            <path
              fill={"#003E85"}
              d="M215.879,355.277a.4.4,0,0,0-.4-.4h-1.4a.4.4,0,0,0-.4.4v1.4a.4.4,0,0,0,.4.4h1.4a.4.4,0,0,0,.4-.4Z"
              transform="translate(-206.106 -341.986)"
            />
            <path
              fill={"#003E85"}
              d="M312.507,355.277a.4.4,0,0,0-.4-.4h-1.4a.4.4,0,0,0-.4.4v1.4a.4.4,0,0,0,.4.4h1.4a.4.4,0,0,0,.4-.4v-1.4Z"
              transform="translate(-299.225 -341.986)"
            />
            <path
              fill={"#003E85"}
              d="M21.2,54.15v2.145a1.752,1.752,0,0,1-1.756,1.751H18.341a1.761,1.761,0,0,1-1.766-1.751V54.142H11.583v2.152a1.761,1.761,0,0,1-1.766,1.751H8.71a1.752,1.752,0,0,1-1.756-1.751V54.15a1.6,1.6,0,0,0-1.543,1.588V68.306A1.6,1.6,0,0,0,7,69.905H21.158a1.6,1.6,0,0,0,1.589-1.6V55.738A1.6,1.6,0,0,0,21.2,54.15ZM20.69,67.524a.687.687,0,0,1-.687.687H8.125a.687.687,0,0,1-.687-.687V61.032a.687.687,0,0,1,.687-.687H20a.687.687,0,0,1,.687.687v6.492Z"
              transform="translate(-5.411 -52.176)"
            />
            <path
              fill={"#003E85"}
              d="M80.152,4.72h1.1a.6.6,0,0,0,.6-.6V.6a.6.6,0,0,0-.6-.6h-1.1a.6.6,0,0,0-.6.6V4.118A.6.6,0,0,0,80.152,4.72Z"
              transform="translate(-76.857)"
            />
            <path
              fill={"#003E85"}
              d="M345.06,4.72h1.1a.6.6,0,0,0,.6-.6V.6a.6.6,0,0,0-.6-.6h-1.1a.6.6,0,0,0-.6.6V4.118A.6.6,0,0,0,345.06,4.72Z"
              transform="translate(-332.144)"
            />
          </g>
        </g>
      </svg>
    ),
    checkIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="94"
        height="94"
        viewBox="0 0 94 94"
      >
        <g transform="translate(-130.267 -292.267)">
          <g
            stroke="#270"
            strokeWidth="20x"
            transform="translate(130.267 292.267)"
          >
            <circle fill="none" cx="47" cy="47" r="47" />
            <circle fill="none" cx="47" cy="47" r="46" />
          </g>
          <g transform="translate(151.743 325.087)">
            <g transform="translate(0 0)">
              <g transform="translate(0 0)">
                <rect
                  fill="#270"
                  width="4.371"
                  height="17.254"
                  transform="translate(0 17.105) rotate(-45)"
                />
                <path
                  fill="#270"
                  d="M226.648,107.891l-3.091-3.091-13.85,13.861,3.091,3.091Z"
                  transform="translate(-188.233 -104.8)"
                />
                <path
                  fill="#270"
                  d="M155.974,104.8,132.84,127.923l-9.109-9.109L120.64,121.9l12.2,12.2,26.214-26.214Z"
                  transform="translate(-108.287 -104.8)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    circleClose: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={height ? height : 42.35}
        width={width ? width : 42.35}
        viewBox="0 0 42.35 42.35"
      >
        <g transform="translate(168.96 -556.493) rotate(45)">
          <circle
            fill="#003E85"
            cx="14.973"
            cy="14.973"
            r="14.973"
            transform="translate(289 498)"
          />
          <g transform="translate(296.442 505.442)">
            <line
              fill="none"
              stroke="#fff"
              strokeWidth="2px"
              y2="14.765"
              transform="translate(7.382)"
            />
            <line
              fill="none"
              stroke="#fff"
              strokeWidth="2px"
              x2="14.765"
              transform="translate(0 7.382)"
            />
          </g>
        </g>
      </svg>
    ),
    edit: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? "15.375"}
        height={height ?? "15.376"}
        viewBox="0 0 15.375 15.376"
      >
        <g transform="translate(0 0.469)">
          <path
            fill="#270"
            d="M14.322,24.241a.587.587,0,0,0-.587.587v4.538H1.177V16.808H5.715a.587.587,0,1,0,0-1.174H.59A.587.587,0,0,0,0,16.221V29.953a.587.587,0,0,0,.587.587H14.322a.587.587,0,0,0,.587-.587V24.828A.587.587,0,0,0,14.322,24.241Z"
            transform="translate(-0.003 -15.634)"
          />
        </g>
        <g transform="translate(4.362)">
          <path
            fill="#270"
            d="M156.105,2.265,154.012.172a.587.587,0,0,0-.83,0L146.257,7.1a.587.587,0,0,0-.15.256l-.822,2.915a.587.587,0,0,0,.724.724l2.915-.822a.588.588,0,0,0,.256-.15l6.925-6.925A.587.587,0,0,0,156.105,2.265Zm-7.646,6.817-1.759.5.5-1.759,6.4-6.4L154.86,2.68Z"
            transform="translate(-145.264 0)"
          />
        </g>
        <g transform="translate(5.375 7.076)">
          <g transform="translate(0 0)">
            <rect
              fill="#270"
              width="1.174"
              height="2.96"
              transform="translate(0 0.83) rotate(-45)"
            />
          </g>
        </g>
      </svg>
    ),
    delete: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13.907"
        height="17.123"
        viewBox="0 0 13.907 17.123"
      >
        <path
          fill="#c00"
          d="M222.8,154.7a.4.4,0,0,0-.4.4v7.579a.4.4,0,1,0,.8,0V155.1A.4.4,0,0,0,222.8,154.7Zm0,0"
          transform="translate(-213.48 -148.499)"
        />
        <path
          fill="#c00"
          d="M104.8,154.7a.4.4,0,0,0-.4.4v7.579a.4.4,0,1,0,.8,0V155.1A.4.4,0,0,0,104.8,154.7Zm0,0"
          transform="translate(-100.212 -148.499)"
        />
        <path
          fill="#c00"
          d="M1.136,5.1v9.88A2.212,2.212,0,0,0,1.724,16.5a1.975,1.975,0,0,0,1.433.62h7.587a1.974,1.974,0,0,0,1.433-.62,2.212,2.212,0,0,0,.588-1.526V5.1a1.532,1.532,0,0,0-.393-3.012H10.319v-.5A1.575,1.575,0,0,0,8.731,0H5.17A1.575,1.575,0,0,0,3.582,1.583v.5H1.529A1.532,1.532,0,0,0,1.136,5.1Zm9.608,11.223H3.157a1.27,1.27,0,0,1-1.219-1.343V5.131H11.963v9.845a1.27,1.27,0,0,1-1.219,1.343ZM4.384,1.583A.773.773,0,0,1,5.17.8H8.731a.773.773,0,0,1,.786.782v.5H4.384Zm-2.855,1.3H12.372a.722.722,0,1,1,0,1.444H1.529a.722.722,0,0,1,0-1.444Zm0,0"
          transform="translate(0.003 0.002)"
        />
        <path
          fill="#c00"
          d="M163.8,154.7a.4.4,0,0,0-.4.4v7.579a.4.4,0,1,0,.8,0V155.1A.4.4,0,0,0,163.8,154.7Zm0,0"
          transform="translate(-156.846 -148.499)"
        />
      </svg>
    ),
    eye: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="20.907"
        height="18.123"
      >
        <g>
          <path
            fill="none"
            stroke="#000"
            d="M12,18.5c-3.6,0-6.5-2.9-6.5-6.5c0-3.6,2.9-6.5,6.5-6.5c3.6,0,6.5,2.9,6.5,6.5C18.5,15.6,15.6,18.5,12,18.5z"
          />
          <path
            fill="none"
            stroke="#000"
            d="M12,14.2c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2C14.2,13.2,13.2,14.2,12,14.2z"
          />
          <g>
            <path
              fill="none"
              stroke="#000"
              d="M22.9,13c-6.2,7.3-15.5,7.3-21.7,0c-0.5-0.6-0.5-1.5,0-2.1c6.2-7.3,15.5-7.3,21.7,0    C23.4,11.5,23.4,12.4,22.9,13z"
            />
          </g>
        </g>
      </svg>
    ),
    backIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11.965"
        height="22.21"
        viewBox="0 0 11.965 22.21"
      >
        <g transform="translate(0 0)">
          <path
            fill={color ? color : "#fff"}
            d="M.25,11.714,10.506,21.97a.855.855,0,0,0,1.208-1.208L2.063,11.11l9.651-9.651A.854.854,0,1,0,10.506.25L.25,10.506A.855.855,0,0,0,.25,11.714Z"
            transform="translate(0 0)"
          />
        </g>
      </svg>
    ),
    selectCheck: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <g transform="translate(-34.5 -242.5)">
          <g transform="translate(36 244)">
            <g fill="#003E85" stroke="#003E85" strokeWidth={"1.5px"}>
              <rect stroke="none" width="13" height="13" />
              <rect
                fill="none"
                x="-0.75"
                y="-0.75"
                width="14.5"
                height="14.5"
              />
            </g>
          </g>
          <path
            strokeWidth={"1.5px"}
            fill="none"
            stroke="#fff"
            d="M-393.947,4034.248l3.444,4.212,6.051-8.187"
            transform="translate(432 -3783.461)"
          />
        </g>
      </svg>
    ),
    selectUnCheck: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <g transform="translate(-34.5 -242.5)">
          <g transform="translate(36 244)">
            <g fill="none" stroke="#003E85" strokeWidth={"1.5px"}>
              <rect stroke="none" width="13" height="13" />
              <rect
                fill="none"
                x="-0.75"
                y="-0.75"
                width="14.5"
                height="14.5"
              />
            </g>
          </g>
        </g>
      </svg>
    ),
    downIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : "12.6"}
        height={height ? height : "6.788"}
        viewBox="0 0 12.6 6.788"
      >
        <g transform="translate(0 6.788) rotate(-90)">
          <g transform="translate(0 0)">
            <path
              fill={color ? color : "#515353"}
              d="M102.439,5.955,108.257.136a.485.485,0,0,1,.686.686L103.467,6.3l5.475,5.475a.485.485,0,1,1-.686.686L102.439,6.64A.485.485,0,0,1,102.439,5.955Z"
              transform="translate(-102.297 0)"
            />
          </g>
        </g>
      </svg>
    ),
    cross: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
        viewBox="0 0 122.88 122.88"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.63,97.99l36.55-36.55L1.63,24.89c-2.17-2.17-2.17-5.73,0-7.9L16.99,1.63c2.17-2.17,5.73-2.17,7.9,0 l36.55,36.55L97.99,1.63c2.17-2.17,5.73-2.17,7.9,0l15.36,15.36c2.17,2.17,2.17,5.73,0,7.9L84.7,61.44l36.55,36.55 c2.17,2.17,2.17,5.73,0,7.9l-15.36,15.36c-2.17,2.17-5.73,2.17-7.9,0L61.44,84.7l-36.55,36.55c-2.17,2.17-5.73,2.17-7.9,0 L1.63,105.89C-0.54,103.72-0.54,100.16,1.63,97.99L1.63,97.99z"
          />
        </g>
      </svg>
    ),
    addCircle: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Group_7517"
        data-name="Group 7517"
        width="17.4"
        height="17.4"
        viewBox="0 0 17.4 17.4"
      >
        <circle
          id="Ellipse_106"
          data-name="Ellipse 106"
          cx="8.7"
          cy="8.7"
          r="8.7"
          fill="#fff"
        />
        <g
          id="Group_5806"
          data-name="Group 5806"
          transform="translate(5.095 5.094)"
        >
          <line
            id="Line_10"
            data-name="Line 10"
            y2="7.211"
            transform="translate(3.605)"
            fill="none"
            stroke="#003E85"
            stroke-width="1"
          />
          <line
            id="Line_11"
            data-name="Line 11"
            x2="7.211"
            transform="translate(0 3.605)"
            fill="none"
            stroke="#003E85"
            stroke-width="1"
          />
        </g>
      </svg>
    ),
    circleCross: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24.093"
        height="24.093"
        viewBox="0 0 24.093 24.093"
      >
        <g transform="translate(159.832 -556.493) rotate(45)">
          <circle
            fill="#003E85"
            cx="8.518"
            cy="8.518"
            r="8.518"
            transform="translate(289 498)"
          />
          <g transform="translate(293.234 502.234)">
            <line
              fill="none"
              stroke="#fff"
              strokeWidth={"2px"}
              y2="8.4"
              transform="translate(4.2)"
            />
            <line
              fill="none"
              stroke="#fff"
              strokeWidth={"2px"}
              x2="8.4"
              transform="translate(0 4.2)"
            />
          </g>
        </g>
      </svg>
    ),
    circleArrowUp: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
      >
        <g>
          <g class="a">
            <circle fill="#fff" cx="10" cy="10" r="10" />
            <circle fill="#003E85" stroke="#fff" cx="10" cy="10" r="9.5" />
          </g>
          <g transform="translate(12.339 8.74) rotate(90)">
            <g transform="translate(0)">
              <path
                fill="#fff"
                stroke="#fff"
                strokeWidth={1}
                d="M.053,2.467l2.16,2.16a.18.18,0,0,0,.255-.255L.434,2.34,2.467.307A.18.18,0,0,0,2.213.053L.053,2.213A.18.18,0,0,0,.053,2.467Z"
              />
            </g>
          </g>
        </g>
      </svg>
    ),
    circleArrowDown: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
      >
        <g>
          <g class="a">
            <circle fill="#fff" cx="10" cy="10" r="10" />
            <circle fill="#003E85" stroke="#fff" cx="10" cy="10" r="9.5" />
          </g>
          <g
            xmlns="http://www.w3.org/2000/svg"
            transform="translate(7.661 11.26) rotate(-90)"
          >
            <g transform="translate(0)">
              <path
                fill="#fff"
                stroke="#fff"
                strokeWidth={1}
                d="M.053,2.21,2.213.051a.18.18,0,0,1,.255.255L.434,2.338,2.467,4.37a.18.18,0,0,1-.255.255L.053,2.465A.18.18,0,0,1,.053,2.21Z"
              />
            </g>
          </g>
        </g>
      </svg>
    ),
    Logout: (
      <svg
        viewBox="0 0 330 330"
        height={height ? height : 20}
        width={width ? width : 24}
      >
        <path
          fill={color ? color : "#000"}
          d="M51.213 180h173.785c8.284 0 15-6.716 15-15s-6.716-15-15-15H51.213l19.394-19.393c5.858-5.857 5.858-15.355 0-21.213-5.856-5.858-15.354-5.858-21.213 0L4.397 154.391c-.348.347-.676.71-.988 1.09-.076.093-.141.193-.215.288-.229.291-.454.583-.66.891-.06.09-.109.185-.168.276-.206.322-.408.647-.59.986-.035.067-.064.138-.099.205-.189.367-.371.739-.53 1.123-.02.047-.034.097-.053.145-.163.404-.314.813-.442 1.234-.017.053-.026.108-.041.162-.121.413-.232.83-.317 1.257-.025.127-.036.258-.059.386-.062.354-.124.708-.159 1.069a14.612 14.612 0 000 2.995c.035.366.099.723.16 1.08.022.124.033.251.058.374.086.431.196.852.318 1.269.015.049.024.101.039.15.129.423.28.836.445 1.244.018.044.031.091.05.135.16.387.343.761.534 1.13.033.065.061.133.095.198.184.341.387.669.596.994.056.088.104.181.162.267.207.309.434.603.662.895.073.094.138.193.213.285.313.379.641.743.988 1.09l44.997 44.997C52.322 223.536 56.161 225 60 225s7.678-1.464 10.606-4.394c5.858-5.858 5.858-15.355 0-21.213L51.213 180z"
        />
        <path
          fill={color ? color : "#000"}
          d="M207.299 42.299c-40.944 0-79.038 20.312-101.903 54.333-4.62 6.875-2.792 16.195 4.083 20.816 6.876 4.62 16.195 2.794 20.817-4.083 17.281-25.715 46.067-41.067 77.003-41.067C258.414 72.299 300 113.884 300 165s-41.586 92.701-92.701 92.701c-30.845 0-59.584-15.283-76.878-40.881-4.639-6.865-13.961-8.669-20.827-4.032-6.864 4.638-8.67 13.962-4.032 20.826 22.881 33.868 60.913 54.087 101.737 54.087C274.956 287.701 330 232.658 330 165S274.956 42.299 207.299 42.299z"
        />
      </svg>
    ),
    default: (
      <svg
        fill={color ? color : "#cccccc"}
        height="24"
        viewBox="0 0 24 24"
        width="24"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z" />
      </svg>
    ),
  };
  return svg[icon || "default"];
};

export default Icon;
